<script setup>
import { apexDashboard } from '@/data/dashboard/apexChart'
import { useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';
import { create_chart_label } from '@/helper';
import card_header from '@/components/card_header.vue';

const route = useRoute()
const props = defineProps({
  assessment: {
    type: Object,
    required: true
  },
})
const series = ref([
  {
    name: 'Score',
    data: [
      {x: 'Baseline', y: 1},
      {x: '4th', y: 2},
      {x: '8th', y: 3}
    ]
  }
])

const isLoading = ref(true)
const chart = ref({})
onMounted(()=>{
  if (props.assessment?.included){
    set_latest_assessment()
    chart.value = build_chart()
    isLoading.value = false
  }
})

const latest_assessment = ref({})
function set_latest_assessment(){
  let progress = props.assessment.included.filter((item)=> item.type == 'assessment_progress')
  let sorted = progress.sort((a,b) =>  parseInt(a.updated_at) - parseInt(b.updated_at))
  latest_assessment.value = props.assessment.data.find((item)=>item.id == sorted[0].attributes.assessment_id) 
}

function build_chart(){
  // chart setting
  let series = [{
    name: 'Score',
    data: []
  }]
  let options = apexDashboard.options
  options.yaxis.max = Math.max(...series[0].data.map(item => item.y)) + 1
  // chart setting end
  let assessment_progresses = props.assessment.included.filter(item => item.type == 'assessment_progress')
  let labels = create_chart_label(assessment_progresses)
  let sorted_progress = assessment_progresses.sort((a,b) =>  parseInt(a.id) - parseInt(b.id))
  let latest_assessment = sorted_progress[sorted_progress.length - 1]?.attributes.assessment_id
  sorted_progress = sorted_progress.filter(item => item.attributes.assessment_id == latest_assessment)
  
  if (assessment_progresses.length !== 0){
    series[0].data = sorted_progress.map((item, ind) => {
      let score = JSON.parse(item.attributes.score);
      // let date = dayjs(item.attributes.created_at).format('D MMM')
      return {
        x: labels[ind], 
        y: score.length
      }
    })
  }
  return {
    show: assessment_progresses.length == 0 ? false : true,
    series,
    options
  }
}
</script>

<template>
  <div class="col-4 card">
    <card_header 
      :title="'Current Assessment'" 
      :has_border="true"
      :is_narrow="true"
    ></card_header>
    <div class="card-body">
      <loadingCard v-if="isLoading"/>
      <template v-else>
        <!-- Assessment Title -->
        <div class="d-flex align-items-center">
          <div class="px-2">
            <p class="fw-medium">{{ latest_assessment.attributes.code }}</p>
          </div>
          <p>
            {{ latest_assessment.attributes.name }}
          </p>
        </div>
  
        <!-- Current chart -->
        <div>
          <apexchart height="200" 
            type="line"
            :options="chart.options" 
            :series="chart.series" 
          ></apexchart>
        </div>
  
        <!-- <div class="row">
          <router-link class="btn btn-light-success rounded-pill m-1 ms-0"
            :to="{name: 'assessment-home', params: {id: route.params.trait_id, child_id: route.params.child_id}}"
          >
            Continue Assessment
          </router-link>
          <router-link class="btn btn-light-success rounded-pill m-1 ms-0"
            :to="{name: 'intervention-home', params: {id: route.params.trait_id, child_id: route.params.child_id}}"
          >
            Do Intervention
          </router-link>
        </div> -->
      </template>
    </div>
  </div>
</template>